export const displayCurrency = (amount: number, useDecimals = false) => {
    const currencyFormat = new Intl.NumberFormat('en-GB', {
        style: 'currency',
        currency: 'GBP'
    }).format(amount);

    return useDecimals
        ? currencyFormat
        : currencyFormat.substring(0, currencyFormat.length - 3);
};
